var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3851_1193115",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -20,
    y: -20,
    width: 160,
    height: 160
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -20,
    width: 160,
    height: 160,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3851_1193115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 57.9489C53.5644 57.9489 48.0667 55.6689 43.5067 51.1089C38.9467 46.55 36.6667 41.0522 36.6667 34.6156C36.6667 28.18 38.9467 22.6822 43.5067 18.1222C48.0667 13.5622 53.5644 11.2822 60 11.2822C66.4356 11.2822 71.9333 13.5622 76.4933 18.1222C81.0533 22.6822 83.3333 28.18 83.3333 34.6156C83.3333 41.0522 81.0533 46.55 76.4933 51.1089C71.9333 55.6689 66.4356 57.9489 60 57.9489ZM10 98.5906V93.8972C10 90.6328 10.8867 87.6094 12.66 84.8272C14.4333 82.045 16.8033 79.9061 19.77 78.4106C26.3589 75.1806 33.0061 72.7578 39.7117 71.1422C46.4172 69.5267 53.18 68.7189 60 68.7189C66.82 68.7189 73.5828 69.5267 80.2883 71.1422C86.9939 72.7578 93.6411 75.1806 100.23 78.4106C103.197 79.9061 105.567 82.045 107.34 84.8272C109.113 87.6094 110 90.6328 110 93.8972V98.5906C110 101.402 109.015 103.793 107.045 105.764C105.075 107.734 102.684 108.719 99.8717 108.719H20.1283C17.3161 108.719 14.925 107.734 12.955 105.764C10.985 103.793 10 101.402 10 98.5906Z",
    fill: "#E8E8E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEmpty);
export default __webpack_public_path__ + "static/media/user_empty.cce82d51a2fd34fb1414b57900b9695f.svg";
export { ForwardRef as ReactComponent };